export default "__VITE_ASSET__CHZ6FBqc__"